export default __webpack_public_path__ + "static/media/blurred.25fc5a3d.jpg";